import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";

interface OwnerRouteProps {
  children: JSX.Element;
}

const OwnerRoute: React.FC<OwnerRouteProps> = ({ children }) => {
  const { fundraiserId } = useParams();
  const campaignDetails = useAppSelector((state) => state.campaigns.campaignDetails.data);
  const userId = useAppSelector((state) => state.user.id);

  const isOwner = campaignDetails?.short_id === fundraiserId && campaignDetails?.user?.id === userId;

  if (!isOwner) {
    return <Navigate to={`/fundraising/${fundraiserId}`} replace />;
  }

  return children;
};

export default OwnerRoute;
